"use client";

import styles from "./Author.module.css";

type Props = {
  /** Optional label text to display above the author card */
  label?: string;
};
export const AuthorLabel = ({ label }: Props) => {
  return !label ? null : (
    <div className={styles.createdByLabel} data-testid="author-label">
      {label}
    </div>
  );
};
